export default {
    amountLabel: 'Outstanding amount (Baht)',
    studentNo: 'Student No.',
    billingHistory: 'Billing History',
    pay: 'Pay',
    receipt: 'Receipt',
    notFound: 'Not found',
    invoice: 'Invoice',
    issueDate: 'Issue Date',
    dueDate: 'Due Date',
    netAmount: 'Net Amount',
    paidOn: 'Paid on',
    status: 'Status',
    paid: 'Paid',
    pending: 'Pending',
    overdue: 'Overdue',
    askedQuest: 'Frequently Asked Questions'
}
